// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__lguM2","employee-header-item":"Header_employee-header-item__JK7TZ"};